<template>
  <div class="stk-radios">
    <label
      v-for="option in options"
      :key="option.value"
      class="stk-radio"
    >
      <input
        :checked="option.value === value"
        type="radio"
        :name="name"
        :value="option.value"
        @change="handleChange"
      >
      {{ option.label }}
    </label>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

defineProps({
  name: {
    type: String,
    required: true,
  },
  value: {
    type: [String, Number],
    required: true,
  },
  options: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(['input']);

const handleChange = event => {
  const newValue = event.target.value;

  emit('input', newValue); // Standard Vue 2 v-model update
};
</script>
